import { BrowserCacheLocation, Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from './environments/environment';
import { ProtectedResource } from '@lib-ui/lib/models/protected-resource';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_signin',
    passwordReset: 'B2C_1_passwordreset',
  },
  authorities: {
    signUpSignIn: {
      authority: environment.AadSignupSigninUrl,
    },
    passwordReset: {
      authority: environment.AadPasswordResetUrl,
    },
  },
  authorityDomain: environment.AadAuthorityDomain,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.AadClientId!,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain!],
    redirectUri: `${window.location.origin}`,
    postLogoutRedirectUri: `${window.location.origin}`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_logLevel, _message, _containsPii) => {
        // console.log(_logLevel, _message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

export function getPublicClientApplication() {
  const msalInstance = new PublicClientApplication(msalConfig);
  return msalInstance;
}

export const protectedResources: ProtectedResource = {
  default: {
    endpoint: '/api/jobs',
    scopes: [environment.AadScope ?? '', 'openid', 'offline_access'],
  },
};

export function GetProtectedResourcesMap(): Map<string, string[]> {
  const map: Map<string, string[]> = new Map([]);
  Object.keys(protectedResources).forEach((element: any) => {
    // @ts-ignore
    const ressource: { endpoint: string; scopes: string[] } = protectedResources[element];
    map.set(ressource.endpoint, ressource.scopes);
  });

  return map;
}
